import AxiosClient from "../../../services/axios.services";

class OverviewServices {
  getOverview = (params) =>
    AxiosClient.get("/api/app/resumen_general_evaluaciones/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getOverviewById = (id) =>
    AxiosClient.get(`/api/app/resumen_general_evaluaciones/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveOverview = (data) =>
    AxiosClient.post("/api/app/resumen_general_evaluaciones/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editOverview = (id, data) =>
    AxiosClient.put(
      `/api/app/resumen_general_evaluaciones/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteOverview = (id) =>
    AxiosClient.delete(`/api/app/resumen_general_evaluaciones/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new OverviewServices();
